"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhoneForwarded = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icon = require("./components/icon.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  color: _propTypes.string
} : {};
var defaultProps = {
  color: '#566'
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["className", "color"]);

  return (0, _core.jsx)("div", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M6.1 1a3.003 3.003 0 013.001 2.59c.117.885.334 1.754.645 2.588a3.002 3.002 0 01-.679 3.17l-.717.716a15 15 0 004.586 4.586l.72-.721a3 3 0 013.164-.676c.836.312 1.705.529 2.6.647A3 3 0 0122 16.93v2.985a3 3 0 01-3.288 2.998 20.78 20.78 0 01-9.058-3.22 20.49 20.49 0 01-6.303-6.3A20.805 20.805 0 01.124 4.27 3 3 0 013.11 1H6.1zm.01 2h-3a1 1 0 00-.996 1.074 18.8 18.8 0 002.92 8.24 18.511 18.511 0 005.7 5.697 18.774 18.774 0 008.176 2.913A1 1 0 0020 19.92v-3.025a.998.998 0 00-.85-1.014 13.845 13.845 0 01-3.032-.755.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 17 17 0 01-6.375-6.375 1 1 0 01.162-1.201l1.266-1.266a1 1 0 00.224-1.057 13.817 13.817 0 01-.753-3.02A1.003 1.003 0 006.11 3zM18.707.293l4 4 .042.044.008.01.03.036-.008-.009.025.03a1.03 1.03 0 01.176.395l.009.053A.944.944 0 0123 5l-.004.085-.007.064-.01.052a.94.94 0 01-.125.32c-.016.025-.032.05-.05.074l-.017.022-.007.008-.073.082-4 4a1 1 0 11-1.414-1.414L19.585 6H14a1 1 0 010-2h5.585l-2.292-2.293A1 1 0 1118.707.293zm4.068 4.077l-.018-.023-.045-.049.063.072z",
    id: "phone-forwarded_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M0 0h48v48H0z"
  }), (0, _core.jsx)("g", {
    transform: "translate(13 13)"
  }, (0, _core.jsx)("mask", {
    id: "phone-forwarded_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#phone-forwarded_svg__a"
  })), (0, _core.jsx)("use", {
    fill: "#889",
    fillRule: "nonzero",
    xlinkHref: "#phone-forwarded_svg__a"
  }), (0, _core.jsx)("g", {
    mask: "url(#phone-forwarded_svg__b)",
    fill: color
  }, (0, _core.jsx)("path", {
    d: "M-13-13h48v48h-48z"
  }))))));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = propTypes : void 0;
Icon.defaultProps = defaultProps;
var IconPhoneForwarded = (0, _stylitas.styled)(Icon)(_templateObject(), _icon.iconBase);
exports.IconPhoneForwarded = IconPhoneForwarded;
IconPhoneForwarded.displayName = 'IconPhoneForwarded';